import React from 'react';
import Page from 'components/Page';
import useDataSource from 'hooks/useDataSource';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import EmptyMessage from 'components/EmptyMessage';
import { EDIT_HEATMAPS, EDIT_SESSION_RECORDINGS } from 'shared/constants/permissions';
import HeatmapCard from './HeatmapCard';
import SessionRecordingCard from './SessionRecordingCard';

const extraFields = `  
  website {
    id
    matomoId
    matomoHeatmaps(dateRanges: [{ predefined: {DATE_RANGE} }]) {
      id
      name
      sampleRate
      samples
      lastSample
      matomoHsrId
    }
    matomoSessionRecordings(dateRanges: [{ predefined: {DATE_RANGE} }]) {
      id
      name
      sampleRate
      samples
      lastSample
      matomoHsrId
    }
  }
`;

const HsrDashboard = () => {
  const { dataSource, dataSourceId } = useDataSource({ extraFields: 'isDemo' });
  const { dataSource: dataSourceWithMatomoData, fetching, hasDataSourcePermission } = useDataSource({ dataSourceId: dataSource?.id, extraFields: extraFields.replaceAll('{DATE_RANGE}', dataSource?.isDemo ? 'ALL_TIME' : 'LAST_30_DAYS') });

  const heatmaps = dataSourceWithMatomoData?.website?.matomoHeatmaps.filter(h => h.samples[0] > 0);
  const sessionRecordings = dataSourceWithMatomoData?.website?.matomoSessionRecordings.filter(h => h.samples[0] > 0);

  const canEditHeatmaps = hasDataSourcePermission(EDIT_HEATMAPS);
  const canEditSessionRecordings = hasDataSourcePermission(EDIT_SESSION_RECORDINGS);

  const noHeatmaps = dataSourceWithMatomoData?.website?.matomoHeatmaps.length === 0;
  const noSessionRecordings = dataSourceWithMatomoData?.website?.matomoSessionRecordings.length === 0;

  return (
    <Page loading={fetching}>
      {(!heatmaps?.length && !sessionRecordings?.length) ? (
        <EmptyMessage
          title="No active heatmaps or recordings"
          subTitle={noHeatmaps && noSessionRecordings ? 'Create a heatmap or recording to start tracking user interactions on your website.' : 'Select a heatmap or recording in the sidebar to view results.'}
          extra={[canEditHeatmaps ? (
            <Link key="create-heatmap" to="manage-heatmaps">
              <Button type="primary">Manage heatmaps</Button>
            </Link>
          ) : null,
          canEditSessionRecordings ? (
            <Link key="create-recording" to="manage-session-recordings">
              <Button type="primary">Manage recordings</Button>
            </Link>
          ) : null,
          ]}
        />
      ) : (
        <>
          <Page.Header
            title="Active Heatmaps & recordings"
          />
          {heatmaps?.map(h => (
            <HeatmapCard key={h.id} dataSourceId={dataSourceId} heatmap={h} canEdit={canEditHeatmaps} />
          ))}
          {sessionRecordings?.map(sr => (
            <SessionRecordingCard key={sr.id} dataSourceId={dataSourceId} sessionRecording={sr} canEdit={canEditSessionRecordings} />
          ))}
        </>
      )}
    </Page>
  );
};

export default HsrDashboard;
